import Vue from 'vue';

function offset(el) {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function animate(from, to, time, elem = document.scrollingElement || document.documentElement, style = 'scrollTop', unit = '') {
  if (!elem)
      return;

  const start = new Date().getTime(),
      timer = setInterval(() => {
          const step = Math.min(1, (new Date().getTime() - start) / time);
          elem[style] = (from + step * (to - from))+unit;

          if (step === 1)
              clearInterval(timer);
      }, 15);

      elem[style] = from+unit;
}

export function scrollTo(el) {
  const top = el === 'header' ? 0 : offset(document.getElementById(el)).top;
  animate(window.scrollY, top, 500);
}

Vue.directive('scrollTo', {
  bind: function(el, binding) {
    el.addEventListener('click', e => {
      e.preventDefault();
      scrollTo(binding.value);
    });
  }
})
